import { callApi, basicApi } from './common'

export default {
  ...basicApi('iam/user'),
  invoice: (seq) => callApi(`billing/user/${seq}/invoice`),
  invoiceDetail: (userSeq, seq) =>
    callApi(`billing/user/${userSeq}/invoice_detail/${seq}`),
}
